var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnknownUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26257_59376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#EEF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99544 9.9987C11.8364 9.9987 13.3288 8.50631 13.3288 6.66536C13.3288 4.82442 11.8364 3.33203 9.99544 3.33203C8.15449 3.33203 6.66211 4.82442 6.66211 6.66536C6.66211 8.50631 8.15449 9.9987 9.99544 9.9987Z",
    fill: "#C9D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53564 16.6561C2.86404 12.9364 5.45354 11.668 9.99996 11.668C14.5211 11.668 17.107 13.2359 17.4586 16.6624C15.6275 18.7115 12.9643 20.0013 9.99996 20.0013C7.03258 20.0013 4.36704 18.7088 2.53564 16.6561Z",
    fill: "#C9D4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26257_59376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownUser);
export default __webpack_public_path__ + "static/media/unknown-user.3ead014ebdd511df5f710015247923e8.svg";
export { ForwardRef as ReactComponent };